export class LocalStorageAdapter {
    set(key, value, ttl = 0) {
        const now = new Date();
        const item = {
            value: value,
            expiry: ttl === 0 ? 0 : (now.getTime() + ttl)
        };
        localStorage.setItem(key, JSON.stringify(item));
    }
    get(key) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        if (item.expiry !== 0 && now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }
}
